<script setup lang="ts">
import { Button } from '@/components/ui/button';
import {
    acceptConsent,
    getConsent,
    loadGoogleAnalytics,
    rejectConsent,
} from '@/composables/useCookieConsent';
import { Link } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';

const visible = ref(false);

onMounted(() => {
    const consent = getConsent();

    if (consent === null) {
        visible.value = true;

        return;
    }

    if (consent === 'accepted') {
        loadGoogleAnalytics();
    }
});

const accept = (): void => {
    acceptConsent();
    visible.value = false;
};

const reject = (): void => {
    rejectConsent();
    visible.value = false;
};
</script>

<template>
  <div
    v-if="visible"
    class="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-background/95 p-4 shadow-lg backdrop-blur-sm"
    role="region"
    aria-labelledby="cookie-consent-title"
    aria-describedby="cookie-consent-description"
  >
    <div class="container mx-auto flex max-w-5xl flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div class="space-y-1 text-sm">
        <p
          id="cookie-consent-title"
          class="font-medium text-foreground"
        >
          Cookies
        </p>
        <p
          id="cookie-consent-description"
          class="text-muted-foreground"
        >
          Usamos cookies analíticas (Google Analytics) en el sitio público para entender el uso del servicio.
          Las cookies necesarias para el funcionamiento no requieren consentimiento.
          Más información en la
          <Link
            href="/privacy-policy"
            class="underline underline-offset-2 hover:text-foreground"
          >
            Política de Privacidad
          </Link>.
        </p>
      </div>
      <div class="flex shrink-0 gap-2">
        <Button
          type="button"
          variant="outline"
          class="cursor-pointer"
          @click="reject"
        >
          Rechazar
        </Button>
        <Button
          type="button"
          class="cursor-pointer"
          @click="accept"
        >
          Aceptar
        </Button>
      </div>
    </div>
  </div>
</template>
